import worldMap from '../core/map';
import halo from '../core/map/halo';
import { pinBuilder } from '../core/map/pinBuilder';
import templates from '../core/templates';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import Leaflet from './Leaflet';

class PGTSLayer {
    constructor (currentMap) {
        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_pgts.png`;

        // const onMoveend = () => get('PGTS', currentMap).filter({ location: true })

        const clusterTemplate = (cluster) => {
            const data = { value: cluster.getChildCount() };

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        const idTipo = environment.get('CONFIG.FILTERS.PGTS')[0] ? environment.get('CONFIG.FILTERS.PGTS')[0].id : 0;
        const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');

        return new Leaflet.D3Layer({
            map: currentMap,
            remote: {
                method: 'POST',
                url: `${environment.get('API_HOST')}/Layer/GetTrafficGenerator`,
                params: {
                    idsTipos: idTipo,
                    isAfterSales: isAfterSales
                }
            },
            // filter: {
            //     location: isAfterSales
            // },
            scaleRange: [8, 20],
            cache: false,
            showAll: false,
            autofocus: false,
            uniqueField: 'Id',
            sort: 'Nome',
            controlRange: 20,
            type: 'decluster',
            legend: {
                title: 'PGTS',
                text: '{Tipo}',
                icon: `${environment.get('IMAGES_HOST')}/pin_{Tipo}.png`
            },
            popup: {
                template (properties) {
                    return templates('map-layer-pgts-label', properties);
                },
                trigger: 'mouseover',
                options: {
                    offset: L.point(0, 0),
                    closeButton: false,
                    autoclose: true
                },
                single: true
            },
            symbology: {
                type: 'polymorph',
                cluster: {
                    template: clusterTemplate
                },
                heat: {
                    scale: 'nomenal',
                    theme: ColorBrewer.getHeatColors('GnBu'),
                    property: 'Peso'
                },
                style: {
                    icon: {
                        fields: ['Tipo'],
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_{Tipo}.png`,
                        iconSize: [18, 18],
                        iconAnchor: [9, 9],
                        labelAnchor: [9, 0]
                    },
                    riseOnHover: true
                }
            }
        });
    }
}

export default PGTSLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/PGTSLayer.js